import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=79e91f9e"
import script from "@/controllers/custom/exam/exam-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/exam/exam-list.js?vue&type=script&lang=js&external"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=79e91f9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports